<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!--      <a-form-model-item label="观看数" prop="lookNum" >-->
      <!--        <a-input v-model="form.lookNum" placeholder="请输入观看数" />-->
      <!--      </a-form-model-item>-->

      <a-form-model-item label="剧名" prop="videoName" >
        <a-input show-count v-model="form.videoName" placeholder="请输入剧名" />
      </a-form-model-item>
<!--      <a-form-model-item label="剧名(英文)" prop="videoNameEn" >-->
<!--        <a-input show-count v-model="form.videoNameEn" placeholder="请输入剧名(英文)" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="简体剧名" prop="videoNameCn" >-->
<!--        <a-input show-count v-model="form.videoNameCn" placeholder="请输入简体剧名" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="马来剧名" prop="videoNameBm" >-->
<!--        <a-input show-count v-model="form.videoNameBm" placeholder="请输入马来剧名" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="印尼剧名" prop="videoNameIn" >-->
<!--        <a-input show-count v-model="form.videoNameIn" placeholder="请输入印尼剧名" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="地区" prop="regionIds" >-->
<!--        <a-checkbox-group v-model="regionIds" @change="onChangeRegionIds" style="width: 100%">-->
<!--          <a-checkbox :value="ite.id" v-for="(ite,idx) in regionManagement">-->
<!--            {{ ite.name }}-->
<!--          </a-checkbox>-->
<!--        </a-checkbox-group>-->
<!--      </a-form-model-item>-->

      <a-form-model-item label="封面图" prop="coverUrl">
        <OssUploadSingle v-model="form.coverUrl" />
      </a-form-model-item>
<!--      <a-form-model-item label="封面图(英文)" prop="coverUrlEn" >-->
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.coverUrlEn"-->
<!--          :showUploadList="false"-->
<!--          :beforeUpload="beforeUpload1"-->
<!--          :customRequest="handleChange1"-->
<!--        >-->
<!--          <plus-outlined />-->
<!--          <img v-if="form.coverUrlEn" :src="form.coverUrlEn" alt="logo" style="height:104px;max-width:300px"/>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoading1 ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">上传</div>-->
<!--          </div>-->
<!--        </a-upload>-->
<!--      </a-form-model-item>-->

      <a-form-model-item label="类型" prop="videoType" >
        <a-select v-model="form.videoType"  placeholder="请选择类型">
          <a-select-option :key="0">免费</a-select-option>
          <a-select-option :key="1">必捷斯</a-select-option>
<!--          <a-select-option :key="2">钻石(精品剧)</a-select-option>-->
<!--          <a-select-option :key="3">会员</a-select-option>-->
        </a-select>
      </a-form-model-item>
<!--      <a-form-model-item label="简体封面圖" prop="coverUrlCn" >-->
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.coverUrlCn"-->
<!--          :showUploadList="false"-->
<!--          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"-->
<!--          :beforeUpload="beforeUpload2"-->
<!--          :customRequest="handleChange2"-->
<!--        >-->
<!--          <plus-outlined />-->
<!--          <img v-if="form.coverUrlCn" :src="form.coverUrlCn" alt="logo" style="height:104px;max-width:300px"/>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoading2 ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">上传</div>-->
<!--          </div>-->
<!--        </a-upload>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="马来封面圖" prop="coverUrlBm" >-->
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.coverUrlBm"-->
<!--          :showUploadList="false"-->
<!--          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"-->
<!--          :beforeUpload="beforeUpload3"-->
<!--          :customRequest="handleChange3"-->
<!--        >-->
<!--          <plus-outlined />-->
<!--          <img v-if="form.coverUrlBm" :src="form.coverUrlBm" alt="logo" style="height:104px;max-width:300px"/>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoading3 ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">上传</div>-->
<!--          </div>-->
<!--        </a-upload>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="印尼封面圖" prop="coverUrlIn" >-->
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.coverUrlIn"-->
<!--          :showUploadList="false"-->
<!--          action="https://8opuad.dodrama.com/admin-api/common/local/file/uploadCos"-->
<!--          :beforeUpload="beforeUpload4"-->
<!--          :customRequest="handleChange4"-->
<!--        >-->
<!--          <plus-outlined />-->
<!--          <img v-if="form.coverUrlIn" :src="form.coverUrlIn" alt="logo" style="height:104px;max-width:300px"/>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoading4 ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">上传</div>-->
<!--          </div>-->
<!--        </a-upload>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="总集数" prop="totalNum" v-if="(formType == 2 && form.sourceType == 0) || formType == 1">
        <a-input-number :min="1" style="width: 100%" v-model="form.totalNum" placeholder="请输入总集数" />
      </a-form-model-item>
      <a-form-model-item label="标签" prop="type" >
        <a-select placeholder="请选择标签" v-model="form.type">
          <a-select-option :key="0">无</a-select-option>
          <a-select-option :key="1">新剧</a-select-option>
          <a-select-option :key="2">爆剧</a-select-option>
<!--          <a-select-option :key="3">会员</a-select-option>-->
<!--          <a-select-option :key="4">精品剧</a-select-option>-->
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="是否上映" prop="isRelease" v-if="(formType == 2 && form.sourceType == 0) || formType == 1">
        <a-select placeholder="请选择是否上映" @change="updateIsGo" v-model="form.isRelease">
          <a-select-option :key="0">否</a-select-option>
          <a-select-option :key="1">是</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item v-if="" label="上映时间" prop="releaseTime" v-if="((formType == 2 && form.sourceType == 0) || formType == 1 )&& this.isGo=='0'">
        <a-date-picker
          :allow-clear="true"
          size="default"
          v-model="form.releaseTime"
          placeholder="上映时间"
          value-format="YYYY-MM-DD"
          format="YYYY-MM-DD">
        </a-date-picker>
      </a-form-model-item>

      <a-form-model-item label="分类" prop="tagIds" >
        <!--        <a-input v-model="form.tagIds" placeholder="请输入标籤ids" />-->
<!--        <a-tree-select-->
<!--          v-model="tagIds"-->
<!--          style="width: 100%"-->
<!--          :tree-data="treeData"-->
<!--          tree-checkable-->
<!--          search-placeholder="请選择分類"-->
<!--          @change="changeSelect"-->
<!--        />-->
        <a-checkbox-group v-model="tagIds" @change="onChange" style="width: 100%">
        <div style="background:#ECECEC; padding:30px" v-for="(item,index) in treeData">

          <a-card :title="item.tagTitle" >

              <a-checkbox :value="ite.id" v-for="(ite,idx) in item.videoTagOptionList">
                {{ ite.tagTitle }}
              </a-checkbox>

          </a-card>

        </div>
        </a-checkbox-group>
      </a-form-model-item>
      <!--      <a-form-model-item label="前多少集可以使用必捷斯观看" prop="limitNum" >-->
      <!--        <a-input-number :min="0" v-model="form.limitNum" placeholder="请输入" />-->
      <!--      </a-form-model-item>-->

      <template v-if="form.videoType == 1 || form.videoType == 2 || form.videoType == 3">
        <a-form-model-item label="前多少集可以免费观看" prop="freeLimitNum" >
          <a-input-number style="width: 100%" :min="0" v-model="form.freeLimitNum" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item  v-if="form.videoType == 2" label="每集钻石价格" prop="diamondPrice" >
          <a-input-number style="width: 100%" :min="0" v-model="form.diamondPrice" placeholder="请输入" />
        </a-form-model-item>
<!--        <a-form-model-item :label="'每集'+  (form.videoType == 1 ? '必捷斯' : '钻石') + '价格(优惠价格)'" prop="discountPrice" >-->
<!--          <a-input-number :min="0" v-model="form.discountPrice" placeholder="请输入" />-->
<!--        </a-form-model-item>-->
        <a-form-model-item label="每集必捷斯价格" prop="goldPrice" v-if="form.videoType == 1 ">
          <a-input-number style="width: 100%" v-model="form.goldPrice" placeholder="请输入"
                          @change="onGoldPriceChange" />
        </a-form-model-item>
      </template>

      <a-form-model-item label="热度值" prop="randomlySorted" >
        <a-input-number v-model="form.randomlySorted" :min="0" :step="1" style="width: 100%;" placeholder="请输入"></a-input-number>
      </a-form-model-item>

      <a-form-model-item label="简介" prop="introductions" >
        <a-textarea show-count :maxLength="500" v-model="form.introductions" placeholder="请输入简介" />
      </a-form-model-item>

<!--      <a-form-model-item label="简介(英文)" prop="introductionsEn" >-->
<!--        <a-textarea show-count :maxLength="500" v-model="form.introductionsEn" placeholder="请输入简介(英文)" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="简体简介" prop="introductionsCn" >-->
<!--        <a-textarea show-count :maxLength="500" v-model="form.introductionsCn" placeholder="请输入简体简介" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="马来简介" prop="introductionsBm" >-->
<!--        <a-textarea show-count :maxLength="500" v-model="form.introductionsBm" placeholder="请输入马来简介" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="印尼简介" prop="introductionsIn" >-->
<!--        <a-textarea show-count :maxLength="500" v-model="form.introductionsIn" placeholder="请输入印尼简介" />-->
<!--      </a-form-model-item>-->

      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入內容" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVideo, addVideo, updateVideo } from '@/api/shortVideo/video/video'
import { listTag } from '@/api/shortVideo/video/tag'
import OssUploadSingle from "@/components/OssUploadSingle";
export default {
  name: 'CreateForm',
  components: {
    OssUploadSingle
  },
  props: {
    regionManagement:{
      type:Array
    }
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      isGo: false,
      tagIds: [],
      regionIds:[],
      // 表单参数
      form: {
        id: null,

        lookNum: null,
        videoType: 0,
        limitNum: null,

        diamondPrice: null,
        discountPrice: null,
        goldPrice: null,
        randomlySorted:0,
        introductions: null,
        introductionsEn: null,
        introductionsCn: null,
        introductionsBm: null,
        introductionsIn: null,

        tagIds: null,

        totalNum: null,
        releaseTime: null,
        videoName: null,
        videoNameEn: null,
        videoNameCn: null,
        videoNameBm: null,
        videoNameIn: null,

        coverUrl: null,
        coverUrlEn: null,
        coverUrlCn: null,
        coverUrlBm: null,
        coverUrlIn: null,

        createTime: null,
        freeLimitNum: null,
        remark: null,
        isRelease: 1
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      uploadLoading: false,
      uploadLoading1: false,
      uploadLoading2: false,
      uploadLoading3: false,
      uploadLoading4: false,
      treeData: [],
      rules: {
        videoType:[
          { required: true, message: '类型不能为空' }
        ],
        lookNum: [
          { required: true, message: '观看数不能为空' }
        ],
        limitNum: [
          { required: true, message: '前多少集可以使用必捷斯观看不能为空' }
        ],
        freeLimitNum: [
          { required: true, message: '前多少集可以免费观看不能为空' }
        ],
        goldPrice: [
          { required: true, message: '每集必捷斯价格不能为空', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback()
              } else if (Number(value) <= 0) {
                callback(new Error('每集必捷斯价格不能小于0'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        tagIds: [
          { required: true, message: '标签不能为空' }
        ],
        totalNum: [
          { required: true, message: '总集数不能为空' }
        ],
        releaseTime: [
          { required: true, message: '请选择上映时间' }
        ],
        videoName: [
          { required: true, message: '剧名不能为空' }

        ],
        videoNameEn: [
          { required: true, message: '英文剧名不能为空' }

        ],
        introductions: [
          { max: 500, message: '简介最多500字' }
        ],
        introductionsEn: [
          { max: 500, message: '简介最多500字' }
        ],
        coverUrl: [
          { required: true, message: '封面图不能为空' }
        ]
      }
    }
  },
  filters: {
  },
  created () {

  },
  computed: {
  },
  watch: {
  },
  mounted () {
    this.getAllList()
  },
  methods: {
    onChange(e,item,ite) {
      this.tagIds = e
      this.form.tagIds = e.join(',')
    },
    onChangeRegionIds(e) {
      this.regionIds = e;
      this.form.regionIds = e
    },
    updateIsGo(value) {
      this.isGo = value
    },
    /*每集必捷斯价格：输入0或负数时提示不能小于0（不做min限制，直接提示）*/
    onGoldPriceChange(value) {
      if (value === null || value === undefined || value === '') {
        return
      }
      if (Number(value) <= 0) {
        this.$message.warning('每集必捷斯价格不能小于0')
      }
    },
    handleChange(info) {
      const that = this
      // new UploadFileToOSS([info.file], {
      //   success: function (fileName) {
      //     console.log(fileName)
      //     that.form.coverUrl = fileName[0].url// 文件名
      //     that.uploadLoading = false
      //   }
      //
      // })
      this.uploadLoading = true;
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrl = fileName[0];//文件名
          that.uploadLoading = false;
        },
      });
    },
    handleChange1(info) {
      this.uploadLoading1 = true;
      const that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlEn = fileName[0]// 文件名
          that.uploadLoading1 = false
        }

      })
    },
    handleChange2(info) {
      const that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlCn = fileName[0]// 文件名
          that.uploadLoading2 = false
        }

      })
    },
    handleChange3(info) {
      const that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlBm = fileName[0]// 文件名
          that.uploadLoading3 = false
        }

      })
      that.uploadLoading3 = false
    },
    handleChange4(info) {
      const that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlIn = fileName[0]// 文件名
          that.uploadLoading4 = false
        }

      })
      that.uploadLoading4 = false
    },
    beforeUpload: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoading = false
        return false
      }
      this.uploadLoading = true;
      this.form.coverUrl = ''
      // TODO 验证文件大小
    },
    beforeUpload1: function (file) {
      console.log('正在上传');
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoading1 = false
        return false
      }
      this.uploadLoading1 = true;
      this.form.coverUrlEn = ''
      // TODO 验证文件大小
    },
    beforeUpload2: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoading2 = false
        return false
      }
      this.form.coverUrlCn = ''
      // TODO 验证文件大小
    },
    beforeUpload3: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoading3 = false
        return false
      }
      this.form.coverUrlBm = ''
      // TODO 验证文件大小
    },
    beforeUpload4: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.uploadLoading4 = false
        return false
      }
      this.form.coverUrlIn = ''
      // TODO 验证文件大小
    },
    handleUpload(info) { // 上传主图(一张图)
      console.log(info)
      const that = this
      this.form.coverUrl = ''
      this.uploadLoading = true
      uploadCos(info.file)
    //  , function (fileName) {
    //   console.log('--------------------------------')
    //   console.log(fileName)
    //   console.log('--------------------------------')
    //   that.uploadLoading = false;
    //   that.form.coverUrl = fileName;
    // }
    },
    changeSelect(e, label, extra) {
      this.tagIds = e
      this.form.tagIds = e.join(',')
    },
    getAllList() {
      listTag().then(res => {
        console.log(res.data);
        res.data.forEach(i => {
          i.selectData = []
        })
        this.treeData = res.data
      })
    },
    onClose () {
      this.tagIds = null
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        lookNum: null,
        limitNum: null,
        diamondPrice: null,
        discountPrice : null,
        goldPrice: null,
        videoType: 0,
        introductions: null,
        introductionsEn: null,
        tagIds: [],
        regionIds:[],
        totalNum: null,
        type: 0,
        videoName: null,
        videoNameEn: null,
        coverUrl: null,
        createTime: null,
        remark: null,
        isRelease: 1,
        releaseTime: null,
        freeLimitNum: null,
        randomlySorted:0,
      }

      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
      this.regionIds = [];
      this.tagIds = [];
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.updateIsGo(0)
      this.isGo = 1
      // this.form={
      //   id: null,
      //
      //   lookNum: null,
      //
      //   limitNum: null,
      //
      //   diamondPrice: null,
      //
      //   goldPrice: null,
      //
      //   introductions: null,
      //   introductionsEn: null,
      //
      //   tagIds: null,
      //
      //   totalNum: null,
      //
      //   videoName: null,
      //   videoNameEn: null,
      //
      //   coverUrl: null,
      //
      //   createTime: null,
      //
      //   remark: null,
      //   isRelease:1
      // }
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getVideo({ 'id': id }).then(response => {
        this.form = response.data
        this.isGo = response.data.isRelease
        if (response.data.tagIds) {
          this.tagIds = response.data.tagIds.split(',')
        } else {
          this.tagIds = []
        }
        if (response.data.regionIds) {
          this.regionIds = response.data.regionIds.split(',')
          this.form.regionIds = response.data.regionIds.split(',').filter(Boolean)
        } else {
          this.regionIds = []
          this.form.regionIds = []
        }
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      // 必捷斯剧集：价格为0或负数时不允许保存（如编辑时回显的历史数据为0）
      if (this.form.videoType == 1 && this.form.goldPrice !== null && this.form.goldPrice !== undefined
        && this.form.goldPrice !== '' && Number(this.form.goldPrice) <= 0) {
        this.$message.warning('每集必捷斯价格不能小于0')
        return
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateVideo(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.tagIds = null
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addVideo(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.tagIds = null
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
